/* any functionality that's shared between component variants but not needed by external components goes in this file */
export var getAboutLinks = function getAboutLinks(envUrl) {
  return [{
    text: 'About Chegg',
    href: "".concat(envUrl, "about/"),
    loggingKey: 'about'
  }, {
    text: 'Chegg For Good',
    href: "".concat(envUrl, "play/student-life/chegg-for-good"),
    loggingKey: 'chegg-for-good'
  }, {
    text: 'College Marketing',
    href: 'https://collegemarketing.chegg.com/',
    loggingKey: 'college-marketing'
  }, {
    text: 'Corporate Development',
    href: 'https://corpdev.chegg.com/',
    loggingKey: 'corporate-development',
    nofollow: true
  }, {
    text: 'Investor Relations',
    href: 'https://investor.chegg.com/',
    loggingKey: 'investor-relations',
    nofollow: true
  }, {
    text: 'Jobs',
    href: 'https://jobs.chegg.com/',
    loggingKey: 'jobs'
  }, {
    text: 'Join Our Affiliate Program',
    href: 'https://www.chegg.com/affiliate-program',
    loggingKey: 'join-our-affiliate-program',
    nofollow: true
  }, {
    text: 'Media Center',
    href: "".concat(envUrl, "press"),
    loggingKey: 'media-center'
  }, {
    text: 'Site Map',
    href: "".concat(envUrl, "sitemap"),
    loggingKey: 'site-map'
  }];
};
export var getLegalLinks = function getLegalLinks(envUrl) {
  return [{
    text: 'Advertising Choices',
    href: 'http://preferences-mgr.truste.com/?pid=chegg01&aid=chegg_pub02&type=cheggdirect',
    loggingKey: 'advertising-choices',
    nofollow: true
  }, {
    text: 'Cookie Notice',
    href: "".concat(envUrl, "cookienotice"),
    loggingKey: 'cookie-notice',
    nofollow: true
  }, {
    text: 'General Policies',
    href: "".concat(envUrl, "generalpolicies"),
    loggingKey: 'general-policies',
    nofollow: true
  }, {
    text: 'Intellectual Property Rights',
    href: "".concat(envUrl, "copyright"),
    loggingKey: 'intellectual-property-rights',
    nofollow: true
  }, {
    text: 'Terms of Use',
    href: "".concat(envUrl, "termsofuse"),
    loggingKey: 'terms-of-use',
    nofollow: true
  }, {
    text: 'Global Privacy Policy',
    // TODO: updated text? https://chegg.atlassian.net/browse/CUI-498
    href: "".concat(envUrl, "privacypolicy"),
    loggingKey: 'privacy-policy',
    nofollow: true
  }, {
    text: 'DO NOT SELL MY INFO',
    href: '#',
    loggingKey: 'do-not-sell-my-info',
    className: 'ot-sdk-show-settings',
    id: 'ot-sdk-btn'
  }, {
    text: 'Honor Code',
    href: "".concat(envUrl, "honorcode"),
    loggingKey: 'honor-code'
  }, {
    text: 'Honor Shield',
    href: "".concat(envUrl, "honor-shield"),
    loggingKey: 'honor-shield' //

  }];
};
export var getProductLinks = function getProductLinks(envUrl) {
  return [{
    text: 'Cheap Textbooks',
    href: "".concat(envUrl, "cheap-textbooks"),
    loggingKey: 'cheap-textbooks'
  }, {
    text: 'Chegg Coupon',
    href: "".concat(envUrl, "chegg-coupon"),
    loggingKey: 'chegg-coupon'
  }, {
    text: 'Chegg Play',
    href: "".concat(envUrl, "play"),
    loggingKey: 'chegg-play'
  }, {
    text: 'Chegg Study Help',
    href: "".concat(envUrl, "study"),
    loggingKey: 'chegg-study-help'
  }, {
    text: 'College Textbooks',
    href: "".concat(envUrl, "college-textbooks"),
    loggingKey: 'college-textbooks'
  }, {
    text: 'eTextbooks',
    href: "".concat(envUrl, "etextbooks"),
    loggingKey: 'eTextbook'
  }, {
    text: 'Flashcards',
    href: "".concat(envUrl, "flashcards"),
    loggingKey: 'flashcards'
  }, {
    text: 'Learn',
    href: "".concat(envUrl, "learn"),
    loggingKey: 'learn'
  }, {
    text: 'Chegg Math Solver',
    href: "".concat(envUrl, "math-solver"),
    loggingKey: 'math-solver'
  }, {
    text: 'Mobile Apps',
    href: "".concat(envUrl, "mobile"),
    loggingKey: 'mobile'
  }, {
    text: 'Solutions Manual',
    href: "".concat(envUrl, "homework-help/solutions-manual"),
    loggingKey: 'solutions-manual'
  }, {
    text: 'Study 101',
    href: "".concat(envUrl, "study-101"),
    loggingKey: 'study-101'
  }, {
    text: 'Textbook Rental',
    href: "".concat(envUrl, "textbooks"),
    loggingKey: 'textbook-rental'
  }, {
    text: 'Used Textbooks',
    href: "".concat(envUrl, "used-textbooks"),
    loggingKey: 'used-textbook'
  }, {
    text: 'Digital Access Codes',
    href: "".concat(envUrl, "access-codes"),
    loggingKey: 'digital-access-codes'
  }, {
    text: 'Chegg Money',
    href: "".concat(envUrl, "money"),
    loggingKey: 'money'
  }];
};
export var getNetworkLinks = function getNetworkLinks() {
  return [{
    text: 'Easybib',
    href: 'https://www.easybib.com/',
    loggingKey: 'easybib'
  }, {
    text: 'Internships.com',
    href: 'https://www.internships.com/',
    loggingKey: 'internships'
  }, {
    text: 'Thinkful',
    href: 'https://www.thinkful.com/',
    loggingKey: 'thinkful'
  }];
};
export var getServiceLinks = function getServiceLinks(envUrl) {
  return [{
    text: 'Customer Service',
    href: "".concat(envUrl, "contactus"),
    loggingKey: 'customer-service'
  }, {
    text: 'Give Us Feedback',
    href: 'mailto:danlr@chegg.com',
    loggingKey: 'give-us-feedback',
    nofollow: true
  }, {
    text: 'Help with eTextbooks',
    href: "".concat(envUrl, "contactus/#/path/eTextbooks"),
    loggingKey: 'help-with-etextbooks'
  }, {
    text: 'Help to use EasyBib Plus',
    href: "".concat(envUrl, "contactus/#/path/Writing/How-to-Use-Writing"),
    loggingKey: 'help-to-use-easybib-plus'
  }, {
    text: 'Manage Chegg Study Subscription',
    href: "".concat(envUrl, "contactus/#/path/Chegg-Study/Managing-My-Membership"),
    loggingKey: 'manage-chegg-study-subscription'
  }, {
    text: 'Return Your Books',
    href: "".concat(envUrl, "returnbooks"),
    loggingKey: 'return-your-books',
    nofollow: true
  }, {
    text: 'Textbook Return Policy',
    href: "".concat(envUrl, "contactus/#/path/Textbooks/Returns"),
    loggingKey: 'textbook-return-policy'
  }];
};